import {createSelector} from 'reselect';
import _ from 'lodash';

// const getVisibilityFilter = (state) => state.visibilityFilter
// const getTodos = (state) => state.todos
//
// export const getVisibleTodos = createSelector(
//     [ getVisibilityFilter, getTodos ],
//     (visibilityFilter, todos) => {
//         switch (visibilityFilter) {
//             case 'SHOW_ALL':
//                 return todos
//             case 'SHOW_COMPLETED':
//                 return todos.filter(t => t.completed)
//             case 'SHOW_ACTIVE':
//                 return todos.filter(t => !t.completed)
//         }
//     }
// )

const getRooms = (state) => state.rooms.data;
const getTotalRooms = (state) => _.get(state.rooms, "total");
const getCurrentUserId = (state) => _.get(state.currentUser.data, "_id");

const hydrateRooms = (rooms, currentUserId, roomsTotal) => {
    rooms = Array.isArray(rooms) ? rooms : [];
    return rooms
        .filter(room => !room.hasError)
        .sort(function (a, b) {
            let dateA = new Date(a.lastMessageCreatedAt), dateB = new Date(b.lastMessageCreatedAt);
            return dateB - dateA
        })
        .map(room => {
            let users = Array.isArray(room.users) ? room.users : [];
            let usersManagement = Array.isArray(room.usersManagement) ? room.usersManagement : [];
            room.participantsWithoutCurrent = users.filter(user => user._id !== currentUserId);
            room.currentUserIsOwner = _.get(room,"owner._id") === currentUserId;
            room.isLocked = !!usersManagement.find(user => user.locked);
            room.hasUserOnline = !room.isLocked && !!users.find(user => (user.online && user._id !== currentUserId));
            room.currentUserIsArchived = !!usersManagement.find(user => (user.archived && user.owner === currentUserId));
            room.currentUserIsLocker = !!usersManagement.find(user => (user.locked && user.owner === currentUserId));
            room.isReadByCurrentUser = !!_.get(usersManagement.find(user => user.owner === currentUserId), 'read');
            room.currentUserId = currentUserId;
            return room;
        });
}

export const getRoomsWithFilter = createSelector(
    [getRooms, getCurrentUserId, getTotalRooms],
    (rooms, currentUserId, roomsTotal) => {
        return hydrateRooms(rooms, currentUserId, roomsTotal);
    }
)